export default __webpack_public_path__ + "static/popups-eed5aaa6794f4c5b9e1e21ace99dbc81.png";